var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25.456,
  height: 39.598,
  viewBox: "0 0 25.456 39.598"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "arrow_icon",
  transform: "translate(-1836.855 -56.059)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M552.512-124.142h20",
  transform: "translate(1364.045 -241.188) rotate(45)",
  fill: "none",
  stroke: "#00baff",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M552.512-124.142h20",
  transform: "translate(2159.557 -402.609) rotate(135)",
  fill: "none",
  stroke: "#00baff",
  strokeLinecap: "round",
  strokeWidth: 8
}))));

export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS40NTYiIGhlaWdodD0iMzkuNTk4IiB2aWV3Qm94PSIwIDAgMjUuNDU2IDM5LjU5OCI+CiAgPGcgaWQ9ImFycm93X2ljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODM2Ljg1NSAtNTYuMDU5KSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xMTIiIGRhdGEtbmFtZT0iUGF0aCAxMTIiIGQ9Ik01NTIuNTEyLTEyNC4xNDJoMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNjQuMDQ1IC0yNDEuMTg4KSByb3RhdGUoNDUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGJhZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI4Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF8xMTMiIGRhdGEtbmFtZT0iUGF0aCAxMTMiIGQ9Ik01NTIuNTEyLTEyNC4xNDJoMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNTkuNTU3IC00MDIuNjA5KSByb3RhdGUoMTM1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBiYWZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iOCIvPgogIDwvZz4KPC9zdmc+Cg==";